import React, { useEffect, useState } from 'react'
import {
  Typography,
  Card,
  CardContent,
  CardMedia,
  CardHeader,
  CircularProgress,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
} from '@material-ui/core'
import styled from 'styled-components'
import { Assignment } from '@material-ui/icons'
import Cookies from 'js-cookie'
import ProdPerfChart from './ProdPerfChart'
import PageHeader from '../PageHeader'

const StyledTableRow = styled(TableRow)(({theme}) => ({
  "&:last-child td, &:last-child th": {
    border: 0
  }
}))

const ProdPerformance = (props) => {
  const { dark } = props
  const token = Cookies.get("token")
  const [productData, setProductData] = useState(null)  
  const [colWidth, setColWidth] = useState(0)
  const colors = ['#8042c5', '#c3a0eb', '#00ca98']

  const getProductData = () => {
    const request = fetch(`https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/prodPerformance`, {headers: {token: token}})

    request.then(response => response.json())
    .then(data => {
      setProductData(data)
    })
  }

  useEffect(() => getProductData(), [])

  if(!productData) return <CircularProgress />

  const getChartData = () => {
    const series = [
      {name: "Yearly Holdout Response Rate", data:[], type: "column", attr: "HO_ResRate"},
      {name: "Yearly Adjusted Response Rate", data:[], type: "column", attr: "Adj_ResRate"},
      {name: "Percent Rolling", data:[], type: "line", attr: "Pct_Rolling"},
    ]    
    
    for(let i = 0; i < productData.length; i++) series.forEach(({data, attr}) => {data.push(productData[i].Data[0][attr] * 100)})

    return series
  }

  const getChartLabelPos = (width) => {    
    setColWidth(width)
  }

  const renderTable = (title, metric) => {  
    return (      
      <Paper className={`product-performance-paper ${dark ? "bg-dk" : "bg-lt"}`}>
        <Table className="product-performance-table">          
          <TableHead>
            <TableRow className="table-head">
              <TableCell colSpan={productData.length} align="center" className="table-head">
                <Typography className="title">{title.toUpperCase()}</Typography>
              </TableCell>
            </TableRow>
            <TableRow>
              {productData.map(({ProductName, Key}, i) => (
                <TableCell key={`${ProductName}-${Key}`} style={{width: `${colWidth}px`}} align="center">
                  <Typography variant="caption" style={{color: `${dark ? "#fff" : "#6e6e6e"}`}}>{ProductName.toUpperCase()}</Typography>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>            
            <StyledTableRow>
              {productData.map(({ProductName, Data}, i) => (
                <TableCell key={`${ProductName}-${i}`} align="center" style={{width: `${colWidth}px`}}>
                  <Typography variant="caption" style={{color: `${dark ? "#fff" : "#6e6e6e"}`}}>
                    {metric === "Pct_Recommend" ?
                      (Data[0][metric] * 100).toLocaleString("en", {minimumFractionDigits: 2, maximumFractionDigits: 2}) + "%"
                    :
                      "$" + (Data[0][metric]).toLocaleString("en", {minimumFractionDigits: 2, maximumFractionDigits: 2})
                    }
                  </Typography>
                </TableCell>
              ))}
            </StyledTableRow>
          </TableBody>
        </Table>
      </Paper>
    )
  }

  return (
    <div id="product-performance">
      <PageHeader details={{icon: <Assignment style={{fontSize: "15px"}}/>, title: "PRODUCT PERFORMANCE SUMMARY"}}/>      
      <br/>
      <div>
        {renderTable("Percentage of Recommended Budget", "Pct_Recommend")}
        <br/>
        <div className={`chart ${dark ?  "bg-dk" : "bg-lt"}`}>
          <ProdPerfChart
            labels={productData.map(({ProductName}) => ProductName)}
            series={getChartData()}
            colors={colors}
            width={"100%"}
            height={700}
            darkMode={dark}
            getPosArr={getChartLabelPos}
          />
        </div>
        <br/>
        {renderTable("Sales Multiplier (Incremnetal ROAS)", "ROI_X")}
      </div>
    </div>
  )
}

export default ProdPerformance
